{
    "ReportlistMyreportlist": "Ma liste de rapports",
    "ReportlistAddreport": "Ajouter un rapport",
    "ReportlistDeletereport": "Supprimer le rapport",
    "ReportlistMoreoptions": "Plus d'options",
    "ReportlistModifyreport": "Modifier le rapport",
    "ReportlistCopyreport": "Rapport de copie",
    "ReportlistRenamefolder": "Renommer un dossier",
    "ReportlistRenamereport": "Renommer le rapport",
    "NoreportsconfiguredText": "Aucun rapport configuré.",
    "ReportlistRecyclebin": "Corbeille",
    "ReportlistEmptyrecyclebin": "Vider la corbeille",
    "ReportlistRestoreallreports": "Restaurer tous les rapports",
    "ReportlistRestorereport": "Rapport de restauration",
    "ReportlistDeletereportsinfolder": "Supprimer le contenu d'un dossier",
    "ReportlistRestorereportsinfolder": "Restaurer le contenu d'un dossier",
    "ReportlistNotAllCompleted": "{} des {} rapports sélectionnés ont été déplacés vers la corbeille.",
    "ReportlistOutof": "de",
    "ReportlistNoreportswererestored": "Aucun rapport n'a été rétabli.",
    "ReportlistReportwasrestored": "Le rapport a été restauré.",
    "ReportlistReportswererestored": "{Les rapports ont été restaurés.",
    "ReportlistXoutofyselectedreportswererestored": "{} des {} rapports sélectionnés ont été restaurés.",
    "ReportlistRestoregenericfailurereason": "Le(s) rapport(s) ayant échoué peuvent avoir été déjà restaurés ou définitivement supprimés.",
    "ReportlistNoreportsweremovedtobin": "Aucun rapport n'a été déplacé vers la corbeille.",
    "ReportlistReportwasmovedtobin": "Le rapport a été déplacé dans la corbeille.",
    "ReportlistReportsweremovedtobin": "Les rapports {} ont été déplacés vers la corbeille.",
    "ReportlistXoutofyselectedreportsweremovedtobin": "{} des {} rapports sélectionnés ont été déplacés vers la corbeille.",
    "ReportlistMovetobingenericfailurereason": "Le(s) rapport(s) échoué(s) ont peut-être déjà été déplacés vers la corbeille.",
    "ReportlistThirtydaysremaining": "Il restera dans votre bac de recyclage pendant 30 jours ou jusqu'à ce qu'il soit vidé.",
    "ReportlistBeendeleted": "a été supprimé.",
    "ReportlistNoreportsweredeletedpermanently": "Aucun rapport n'a été supprimé définitivement.",
    "ReportlistReportwasdeletedpermanently": "Le rapport a été supprimé définitivement.",
    "ReportlistReportsweredeletedpermanently": "Les rapports {} ont été supprimés définitivement.",
    "ReportlistXoutofyselectedreportsweredeletedpermanently": "{} des {} rapports sélectionnés ont été supprimés définitivement.",
    "ReportlistDeletepermanentlygenericfailurereason": "Le(s) rapport(s) qui a(ont) échoué peut(vent) avoir été déjà supprimé(s) ou restauré(s) de manière permanente et ne plus se trouver dans la corbeille.",
    "ReportlistMoveToBinCondition": "À l'avenir, ne me montrez pas cette boîte de dialogue.",
    "ReportlistNoreportswerecopied": "Aucun rapport n'a été copié.",
    "ReportlistReportwascopied": "Le rapport a été copié.",
    "ReportlistReportswerecopied": "{} Les rapports ont été copiés.",
    "ReportlistXoutofyselectedreportswerecopied": "{} sur {} rapports sélectionnés ont été copiés.",
    "ReportlistCopygenericfailurereason": "Le(s) rapport(s) échoué(s) ont peut-être déjà été déplacés vers la corbeille.",
    "NAME": "LanguageMyReportList",
    "ReportlistAdddefaultreport": "Ajouter un rapport par défaut",
    "ReportListCopyReportsSuccessfulMessage": "Copie réussie de {} rapport(s)",
    "ReportlistOverrideExistingReport": "Cochez cette case si vous souhaitez remplacer vos rapports existants.",
    "ReportlistReportsKeptForThirtyDays": "Les rapports ignorés seront conservés dans la corbeille pendant 30 jours ou jusqu'à ce qu'ils soient vidés."
}